import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import AuthLayout from '../components/auth/AuthLayout';
import AuthResult from '../components/auth/AuthResult';
import Alert from '../components/ui/Alert';
import Button from '../components/ui/Button';
import { buttonClassName } from '../components/ui/buttonStyles';
import { FormField, Input } from '../components/ui/Field';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      const response = await api.post('/users/forgot-password', { email });
      setStatus('success');
      setMessage(response.data.message || 'Se o email estiver cadastrado, você receberá um link para redefinir sua senha.');
    } catch (error: any) {
      // Always show success for security reasons (don't reveal if email exists)
      setStatus('success');
      setMessage('Se o email estiver cadastrado, você receberá um link para redefinir sua senha.');
    }
  };

  if (status === 'success') {
    return (
      <AuthLayout>
        <AuthResult
          tone="success"
          title="Email Enviado!"
          actions={(
            <div className="flex gap-3">
              <Button
                variant="secondary"
                className="flex-1"
                onClick={() => {
                  setStatus('idle');
                  setEmail('');
                  setMessage('');
                }}
              >
                Enviar Novamente
              </Button>
              <Link to="/login" className={`${buttonClassName()} flex-1`}>
                Voltar ao Login
              </Link>
            </div>
          )}
        >
          <p>{message}</p>
          <Alert variant="info" className="text-left">
            <strong>O link expira em 1 hora.</strong>
            <br />
            Não recebeu o email? Verifique sua caixa de spam.
          </Alert>
        </AuthResult>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Esqueci minha senha" subtitle="Informe seu email para receber o link de redefinição">
      <form onSubmit={handleSubmit} className="space-y-4">
        {status === 'error' && message && <Alert variant="danger">{message}</Alert>}

        <FormField htmlFor="email" label="Email">
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="seu-email@exemplo.com"
            disabled={status === 'loading'}
          />
        </FormField>

        <Button type="submit" fullWidth loading={status === 'loading'}>
          {status === 'loading' ? 'Enviando...' : 'Enviar Link de Redefinição'}
        </Button>

        <div className="text-center">
          <Link to="/login" className="text-sm text-link transition hover:text-link-hover">
            Voltar ao Login
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
